import { Form, Formik } from 'formik';
import { useRef } from 'react';
import * as bd from 'react-basic-design';
import * as yup from 'yup';
import { accountApi } from '../../../api/account-api';
import { notify } from '../../../components/basic/notify';
import { T, translate } from '../../../components/basic/text';
import { useWaiting } from '../../../components/basic/use-waiting';
import { FormikTextField } from '../../../components/formik/formik-text-field';
import { languages } from '../../../app/constatnts';
import { SectionTitle } from '../../../components/ui/section-title';

export const UserChangeProfile = ({ model, setModel }) => {
    const waiting = useWaiting();
    const formRef = useRef();
    const onSaveClick = () => {
        if (!formRef.current) return false;
        if (!formRef.current.isValid) return false;
        var data = formRef.current.values;
        waiting.start();
        accountApi
            .updateUserProfile(data)
            .then(x => {
                setModel({ ...model, user: x, _id: 'view' });
                notify.info(translate('changes-are-saved'));
            })
            .catch(notify.error)
            .finally(waiting.stop);
    };

    const initialValues = {
        firstName: model.user.firstName,
        lastName: model.user.lastName,
        defaultLanguage: model.user.defaultLanguage,
        email: model.user.email,
        phoneNumber: model.user.phoneNumber,
    };
    return (
        <div>
            <SectionTitle title="edit-profile" />
            <div>
                <Formik
                    initialValues={initialValues}
                    validationSchema={yup.object({
                        email: yup.string().email(' ').nullable(true),
                        phoneNumber: yup.string().required(' '),
                    })}
                    onSubmit={onSaveClick}
                    innerRef={formRef}
                >
                    {formik => (
                        <Form className="pb-3">
                            <FormikTextField
                                name="firstName"
                                label={<T>first-name</T>}
                                labelWidth={4}
                                autoComplete="off"
                                autoFocus
                            />
                            <FormikTextField
                                name="lastName"
                                label={<T>last-name</T>}
                                labelWidth={4}
                                autoComplete="off"
                            />

                            <FormikTextField
                                name="email"
                                label={<T>email</T>}
                                inputClassName="ltr"
                                labelWidth={4}
                                autoComplete="off"
                            />
                            <FormikTextField
                                name="phoneNumber"
                                inputClassName="ltr"
                                label={<T>phone-number</T>}
                                labelWidth={4}
                                autoComplete="off"
                            />
                            <FormikTextField
                                label={<T>default-language</T>}
                                labelWidth={4}
                                name="defaultLanguage"
                                type="select"
                                items={[{ id: '', title: '' }, ...languages]}
                                footer={
                                    <T>
                                        the-default-language-for-determining-the-language-of-receiving-messages-is-sms-and-email.
                                    </T>
                                }
                            />
                            <bd.Flex className="p-e-4" align="center" gap={3} content="end">
                                <bd.Button variant="contained" disabled={!formik.isValid}>
                                    <span>{<T>save-changes</T>}</span>
                                </bd.Button>

                                <bd.Button
                                    type="button"
                                    variant="outline"
                                    onClick={() => setModel({ ...model, _id: 'view' })}
                                >
                                    <span>{<T>cancel</T>}</span>
                                </bd.Button>
                            </bd.Flex>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
